<template>
  <div>
    <b-card id="listParticipantes" no-body style="display: none" class="pt-1">
      <b-card>
        <div class="dashboard">
          <b-row class="mx-1 mb-1 p-3 chart-dashboard">
            <div v-if="loadingDashboard">
              <b-spinner class="align-middle"></b-spinner> &emsp;
              <strong>Cargando dashboard...</strong>
          </div>
          <div class = "chart-dashboard" v-else>
              <DonutChart
                v-if="tipoEvento === 'REGISTRO DE ASISTENCIA'"
                :entregados="entregados"
                :con_absentismos="con_absentismos"
                :sin_absentismos="sin_absentismos"
                :titulo="`Público Objetivo:`"
                tooltipText="personas"
                chartClass="large-chart-dashboard"
                :labels="['Asistencias', 'Con absentismos','Sin absentismos']"
              />
              <div v-else-if="tipoEvento === 'ENTREGA DE PRESENTES'" class="charts-container">
                <DonutChart
                  :entregados="entregados"
                  :con_absentismos="con_absentismos"
                  :sin_absentismos="sin_absentismos"
                  :titulo="`Público Objetivo:`"
                  tooltipText="personas"
                  chartClass="small-chart"
                  :labels="['Entregados', 'Con absentismos','Sin absentismos']"
                />
                <DonutChart
                  :entregados="entregados"
                  :con_absentismos="nPremios - entregados"
                  :sin_absentismos="0"
                  :titulo="`Número de Premios:`"
                  tooltipText="premios"
                  chartClass="small-chart"
                  :labels="['Entregados', 'No entregados']"
                />
              </div>
            </div>
          </b-row>
        </div>
      </b-card>
      <div class="">
        <b-row class="mx-1 mb-1">
          <b-col lg="5" md="6" sm="12" class="mb-1">
            <b-button
              variant="gradient-primary"
              @click="regresar"
              id="btn_back"
              v-b-tooltip.hover="'Regresar'"
              size="sm"
            >
              <font-awesome-icon icon="fa-solid fa-arrow-left-long" />
            </b-button>
            <b-button
              variant="gradient-primary"
              class="ml-1"
              @click="exportarFileV2"
              v-b-tooltip.hover="'Descargar Excel'"
              :disabled="loading_exp"
              size="sm"
            >
              <feather-icon
                :icon="`${loading_exp ? 'RefreshCwIcon' : 'FileTextIcon'}`"
                :class="`${loading_exp ? 'spinner' : ''}`"
              />&emsp13;
              <span v-if="loading_exp">Generando Excel</span>
            </b-button>
            <b-button
              variant="gradient-primary"
              class="ml-1"
              @click="exportarPDFMasivos"
              v-b-tooltip.hover="'Descargar PDFs'"
              :disabled="loading_pdf"
              size="sm"
              v-if="tipoEvento === 'ENTREGA DE PRESENTES' && firmaFoto === 'SI'"
            >
            <feather-icon
                :icon="`${loading_pdf ? 'RefreshCwIcon' : 'FileTextIcon'}`"
                :class="`${loading_pdf ? 'spinner' : ''}`"
              />
              &emsp13;
              <span v-if="loading_pdf">Generando PDFs</span>
            </b-button>
            &emsp;
            <b style="vertical-align: middle">Evento: {{ nombreEvento }}</b>
          </b-col>
          <b-col lg="2" md="6" sm="12" class="mb-1">
            <v-select
              id="estado_f"
              v-model="estadoSelected"
              :options="estados"
              :reduce="(estados) => estados.value"
              label="text"
              key="value"
              placeholder="Filtrar estado..."
              :disabled="loadingParticipantes"
              @input="filtros2"
              class="select-size-sm"
            />
          </b-col>
          <b-col lg="3" md="6" sm="12" class="mb-1">
            <b-form-input
              id="filterInput"
              v-model="filtro"
              type="search"
              placeholder="Buscar DNI - NOMBRES - APELLIDOS"
              :disabled="loadingParticipantes"
              @input="filtros2"
              size="sm"
            />
          </b-col>
          <b-col lg="2" md="6" sm="12" class="text-right mb-1">
            <b style="vertical-align: -webkit-baseline-middle"
              >Total de registros:
              {{
                items_participantes.length.toLocaleString("pe-PE", {
                  minimumFractionDigits: 0,
                })
              }}
            </b>
          </b-col>
        </b-row>
      </div>
      <b-table
        hover
        responsive
        small
        class="position-relative"
        :per-page="perPage"
        :current-page="currentPage"
        :items="items_participantes"
        :fields="fields_participantes"
        @filtered="cPaginacion"
        :busy="loadingParticipantes"
        show-empty
        empty-text="No se encontraron datos en esta tabla."
        emptyFilteredText="No se encontraron datos con los parámetros ingresados."
      >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>
        <template #cell(acciones)="data">
          <b-button
            v-if="tipoEvento === 'ENTREGA DE PRESENTES' && firmaFoto === 'SI'"
            variant="outline-primary"
            size="sm"
            class="px-2 py-1"
            @click="handleDescargarPDF(data.item)"
          >
            <feather-icon icon="DownloadIcon" class="mr-1" /> Descargar PDF
          </b-button>
        </template>
        <template #cell(estado)="data">
          <b-badge :variant="status_participante[1][parseInt(data.value)]">
            {{ status_participante[0][parseInt(data.value)] }}
          </b-badge>
        </template>
        <template #cell(created)="data">
          <span class="text-nowrap">
            {{
              new Date(data.value).toLocaleString("pe-PE", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                localeMatcher: "best fit",
                timeZone: "America/Lima",
              })
            }}
          </span>
        </template>
        <template #cell(modified)="data">
          <span class="text-nowrap">
            {{
              new Date(data.value).toLocaleString("pe-PE", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                localeMatcher: "best fit",
                timeZone: "America/Lima",
              })
            }}
          </span>
        </template>
        <template #cell(evaluador_nombre)="data">
          <span v-if="data.value !== ''" class="text-nowrap">
            {{ data.value }}
          </span>
          <span v-else class="text-nowrap"> Sin Evaluador </span>
        </template>
      </b-table>
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group
          label="Mostrar"
          label-cols="5"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect2"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
          />
        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </b-card>

    <b-card id="listEventos" no-body class="pt-1">
      <div>
        <b-row class="mb-1">
          <b-col cols="12" md="12">
              <b-button
                id="update"
                variant="primary"
                @click="traerEventos"
                :disabled="loading"
                v-b-tooltip.hover="'Actualizar data'"
                class="mx-1"
                size="sm"
              >
                <span v-if="loading"
                  ><b-spinner style="width: 15px; height: 15px"
                /></span>
                <span v-else><feather-icon icon="RefreshCwIcon" /></span>
              </b-button>
              <b-button
                v-if="$can('create', 'Eventos BBSS')"
                variant="primary"
                @click="abrirModalCrear"
                v-b-tooltip.hover="'Insertar Nuevo Evento'"
                size="sm"
              >
                <span class="text-nowrap">Agregar Evento</span>
              </b-button>
              <b-button
                    variant="gradient-primary"
                    size="sm"
                    class="mx-1"
                    @click="exportarFile('ENTREGA DE PRESENTES')"
                    :disabled="loadingExcel"
                    v-b-tooltip.hover="'Exportar a Excel (Entregas)'"
                >
                <feather-icon
                  :icon="`${loading_exp ? 'RefreshCwIcon' : 'FileIcon'}`"
                  :class="`${loading_exp ? 'spinner' : ''}`"
                />&emsp13;
                <span v-if="loading_exp">Generando Excel</span>
              </b-button>
              <b-button
                    variant="gradient-primary"
                    size="sm"
                    @click="exportarFile('REGISTRO DE ASISTENCIA')"
                    :disabled="loadingExcel"
                    v-b-tooltip.hover="'Exportar a Excel (Asistencias)'"
                >
                <feather-icon
                  :icon="`${loading_expV2 ? 'RefreshCwIcon' : 'FileIcon'}`"
                  :class="`${loading_expV2 ? 'spinner' : ''}`"
                />&emsp13;
                <span v-if="loading_expV2 ">Generando Excel</span>
              </b-button>
          </b-col>

          <!--
          <b-col
              cols="12"
              md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                  class="d-inline-block mr-1"
                  placeholder="Buscar..."
                  size="sm"
              />
            </div>
          </b-col>
          -->
        </b-row>
      </div>
      <b-col cols="12" class="mt-0 pt-0">
        <hot-table ref="hotTableEntregas" :data="itemsEntregas" licenseKey='non-commercial-and-evaluation' ></hot-table>
      </b-col>
      <!--
      <b-table
        hover
        responsive
        class="position-relative"
        :per-page="perPage"
        :current-page="currentPage"
        :items="items"
        :fields="fields"
        @filtered="cPaginacion"
        :busy="loading"
        show-empty
        empty-text="No se encontraron datos en esta tabla."
        emptyFilteredText="No se encontraron datos con los parámetros ingresados."
      >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>
        <template #cell(estado)="data">
          <b-badge :variant="status[1][parseInt(data.value)]">
            {{ status[0][parseInt(data.value)] }}
          </b-badge>
        </template>
        <template #cell(acciones)="data">
          <div class="text-nowrap">
            <feather-icon
                :id="`btn_${data.item.id}_editar`"
                icon="EditIcon"
                class="mr-1"
                @click="abrirModalEditar(data.item)"
                @click="abrirModalEditar(data.item)"
                v-b-tooltip.hover="'Editar evento'"
            />

            <feather-icon
                :id="`btn_${data.item.dni}_detalle`"
                icon="EyeIcon"
                size="16"
                class="text-primary"
                @click="
                tablaParticipantes(
                  data.item.id,
                  data.item.nombre,
                  data.item.sede,
                  data.item.modified
                )
              "
                v-b-tooltip.hover="'Ver detalle'"
            />
          </div>
        </template>
        <template #cell(fecha_inicio)="data">
          <span class="text-nowrap">
            {{
              new Date(data.value.split("-")).toLocaleString("pe-PE", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                localeMatcher: "best fit",
                timeZone: "America/Lima",
              })
            }}
          </span>
        </template>
        <template #cell(fecha_fin)="data">
          <span class="text-nowrap">
            {{
              new Date(data.value.split("-")).toLocaleString("pe-PE", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                localeMatcher: "best fit",
                timeZone: "America/Lima",
              })
            }}
          </span>
        </template>
        <template #cell(n_participantes)="data">
          <span class="text-nowrap">
            {{
              data.value.toLocaleString("pe-PE", { minimumFractionDigits: 0 })
            }}
          </span>
        </template>
      </b-table>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <b-form-group
          label="Mostrar"
          label-cols="5"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect2"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
          />
        </b-form-group>
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
      -->

    </b-card>
    <b-modal
      id="modal-descarga-pdf"
      v-model="loadingPDF"
      title="Descargando PDF"
      hide-footer
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
      centered
    >
      <div class="text-center">
        <b-spinner label="Loading..." variant="primary" />
        <p class="mt-2"><b>Descargando PDF, por favor espera...</b></p>
      </div>
    </b-modal>

    <b-modal
      id="modal-prevent-closing"
      v-model="estadoModal"
      ref="my-modal"
      title="Registrar Evento"
      ok-title="Registrar"
      cancel-title="Cancelar"
      cancel-variant="outline-secondary"
      :size="loading2 ? 'md' : 'lg'"
      :cancel-disabled="loading2"
      :ok-disabled="loading2"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @ok="handleOk"
      @show="resetModal"
    >
      <div v-if="loading2" align="center">
        <p>Registrando ...</p>
        <b-spinner label="Loading..." variant="primary" />
        <br />
        <br />
        <p><b>No cierres esta ventana hasta que el proceso termine.</b></p>
      </div>
      <validation-observer v-else ref="formularioEvento" #default="{ invalid }">
        <b-form autocomplete="off" @submit.prevent="handleSubmit">
          <b-row>
            <b-col lg="12">
              <b-form-group label="Tipo de Evento" label-for="tipo_evento">
                <validation-provider
                  #default="{ errors }"
                  name="Tipo de Evento"
                  vid="tipo_evento"
                  rules="required"
                >
                  <v-select
                    id="tipo_evento"
                    v-model="tipo_evento"
                    :options="tipo_eventoLista"
                    label="Tipo de Evento"
                    placeholder="Seleccionar Tipo de Evento..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Evento" label-for="evento">
                <validation-provider
                  #default="{ errors }"
                  name="Evento"
                  vid="evento"
                  rules="required"
                >
                  <b-form-input
                    id="evento"
                    v-model="evento"
                    :state="errors.length > 0 ? false : null"
                    name="evento"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Descripción" label-for="descripcion">
                <validation-provider
                  #default="{ errors }"
                  name="Descripción"
                  vid="descripcion"
                  rules="required"
                >
                  <b-form-input
                    id="descripcion"
                    v-model="descripcion"
                    :state="errors.length > 0 ? false : null"
                    name="descripcion"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Fecha Inicio" label-for="fecha_inicio">
                <validation-provider
                  #default="{ errors }"
                  name="Fecha Inicio"
                  vid="fecha_inicio"
                  rules="required"
                >
                  <b-form-datepicker
                    id="fecha_inicio"
                    v-model="fecha_inicio"
                    :date-format-options="{
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    }"
                    :hide-header="true"
                    start-weekday="1"
                    v-bind="labels || {}"
                    today-button
                    reset-button
                    close-button
                    :state="errors.length > 0 ? false : null"
                    name="fecha_inicio"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Fecha Fin" label-for="fecha_fin">
                <validation-provider
                  #default="{ errors }"
                  name="Fecha Fin"
                  vid="fecha_fin"
                  rules="required"
                >
                  <b-form-datepicker
                    id="fecha_fin"
                    v-model="fecha_fin"
                    :date-format-options="{
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    }"
                    :hide-header="true"
                    start-weekday="1"
                    v-bind="labels || {}"
                    today-button
                    reset-button
                    close-button
                    :state="errors.length > 0 ? false : null"
                    name="fecha_fin"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4" v-if="tipo_evento === 'ENTREGA DE PRESENTES'">
              <b-form-group label="N° de Premios" label-for="n_premios">
                <validation-provider
                    #default="{ errors }"
                    name="N° de Premios"
                    vid="n_premios"
                    rules="required"
                >
                  <b-form-input
                      id="n_premios"
                      v-model="n_premios"
                      :state="errors.length > 0 ? false : null"
                      name="n_premios"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4" v-if="tipo_evento === 'ENTREGA DE PRESENTES'">
              <b-form-group label="Código de Barras" label-for="codigo_barras">
                <validation-provider
                  #default="{ errors }"
                  name="Código de Barras"
                  vid="codigo_barras"
                  rules="required"
                >
                  <v-select
                    id="codigo_barras"
                    v-model="codigo_barras"
                    :options="codigo_barrasLista"
                    label="Código de Barras"
                    placeholder="Seleccionar Código de Barras..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4" v-if="tipo_evento === 'ENTREGA DE PRESENTES'">
              <b-form-group label="¿Firma y Foto?" label-for="firma_foto">
                <validation-provider
                  #default="{ errors }"
                  name="Firma y Foto"
                  vid="firma_foto"
                  rules="required"
                >
                  <v-select
                    id="firma_foto"
                    v-model="firma_foto"
                    :options="firma_fotoLista"
                    label="Firma y Foto"
                    placeholder="Seleccionar Firma y Foto..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4" v-if="firma_foto === 'NO' && tipo_evento === 'ENTREGA DE PRESENTES'">
              <b-form-group label="Nombre del premio" label-for="nombre_premio">
                <validation-provider
                  #default="{ errors }"
                  name="Nombre de premio"
                  vid="nombre_premio"
                  rules="required"
                >
                <b-form-input
                      id="nombre_premio"
                      v-model="nombre_premio"
                      :state="errors.length > 0 ? false : null"
                      name="nombre_premio"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12" class="mb-1 mt-1">
              Perfil del colaborador que participará en el evento:
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="5">
              <b-form-group label="Tipo" label-for="tipo">
                <validation-provider
                  #default="{ errors }"
                  name="Tipo"
                  vid="tipo"
                  rules="required"
                >
                  <v-select
                    id="tipo"
                    v-model="tipo"
                    :options="tipoLista"
                    label="nombre_tipo_planilla"
                    placeholder="Seleccionar tipo..."
                    multiple
                    @input="cambiarTipo"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="7" v-if="opcionBool">
              <b-form-group label="Opción" label-for="opcion">
                <validation-provider
                  #default="{ errors }"
                  name="Opción"
                  vid="opcion"
                  rules="required"
                >
                  <v-select
                    id="tipo"
                    v-model="opcion"
                    :options="opcionLista"
                    label="nombre_opcion_planilla"
                    placeholder="Seleccionar opcion..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col :lg="opcionBool ? '12' : '7'">
              <b-form-group label="Sede" label-for="sede">
                <validation-provider
                  #default="{ errors }"
                  name="Sede"
                  vid="sede"
                  rules="required"
                >
                  <v-select
                    id="sede"
                    v-model="sede"
                    :options="sedeLista"
                    label="sede"
                    placeholder="Seleccionar sede..."
                    multiple
                    @input="cambiarSede"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Género" label-for="genero">
                <validation-provider
                  #default="{ errors }"
                  name="Género"
                  vid="genero"
                  rules="required"
                >
                  <v-select
                    id="genero"
                    v-model="genero"
                    :options="generoLista"
                    label="genero"
                    placeholder="Seleccionar genero..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Hijos" label-for="hijos">
                <validation-provider
                  #default="{ errors }"
                  name="Hijos"
                  vid="hijos"
                  rules="required"
                >
                  <v-select
                    id="hijos"
                    v-model="hijos"
                    :options="hijosLista"
                    label="asignacion_familiar"
                    placeholder="Seleccionar hijos..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal
      id="modal-editar"
      v-model="estadoModalEditar"
      ref="modal-editar"
      title="Editar Evento"
      ok-title="Editar"
      cancel-title="Cancelar"
      cancel-variant="outline-secondary"
      :size="loadingEditar ? 'md' : 'lg'"
      :cancel-disabled="loadingEditar"
      :ok-disabled="loadingEditar"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @ok="handleOkEditar"
      @close="resetModal"
    >
      <div v-if="loadingEditar" align="center">
        <p>Editando ...</p>
        <b-spinner label="Loading..." variant="primary" />
        <br />
        <br />
        <p><b>No cierres esta ventana hasta que el proceso termine.</b></p>
      </div>
      <validation-observer v-else ref="formularioEventoEditar" #default="{ invalid }">
        <b-form autocomplete="off" @submit.prevent="handleSubmitEditar">
          <b-row>
            <b-col lg="6">
              <b-form-group label="Evento" label-for="evento">
                <validation-provider
                  #default="{ errors }"
                  name="Evento"
                  vid="evento"
                  rules="required"
                >
                  <b-form-input
                    id="evento"
                    v-model="evento"
                    :state="errors.length > 0 ? false : null"
                    name="evento"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Descripción" label-for="descripcion">
                <validation-provider
                  #default="{ errors }"
                  name="Descripción"
                  vid="descripcion"
                  rules="required"
                >
                  <b-form-input
                    id="descripcion"
                    v-model="descripcion"
                    :state="errors.length > 0 ? false : null"
                    name="descripcion"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Fecha Inicio" label-for="fecha_inicio">
                <validation-provider
                  #default="{ errors }"
                  name="Fecha Inicio"
                  vid="fecha_inicio"
                  rules="required"
                >
                  <b-form-datepicker
                    id="fecha_inicio"
                    v-model="fecha_inicio"
                    :date-format-options="{
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    }"
                    :hide-header="true"
                    start-weekday="1"
                    v-bind="labels || {}"
                    today-button
                    reset-button
                    close-button
                    :state="errors.length > 0 ? false : null"
                    name="fecha_inicio"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Fecha Fin" label-for="fecha_fin">
                <validation-provider
                  #default="{ errors }"
                  name="Fecha Fin"
                  vid="fecha_fin"
                  rules="required"
                >
                  <b-form-datepicker
                    id="fecha_fin"
                    v-model="fecha_fin"
                    :date-format-options="{
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    }"
                    :hide-header="true"
                    start-weekday="1"
                    v-bind="labels || {}"
                    today-button
                    reset-button
                    close-button
                    :state="errors.length > 0 ? false : null"
                    name="fecha_fin"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group label="Estado" label-for="estado">
                <validation-provider
                    #default="{ errors }"
                    name="Estado"
                    vid="estado"
                    rules="required"
                >
                  <v-select
                      id="estado_f"
                      v-model="estadoEditarSelected"
                      :options="estadosEditar"
                      :clearable="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col lg="12" class="mb-1 mt-1">
              Perfil del colaborador que participará en el evento:
            </b-col>

            <b-col lg="6">
              <b-form-group label="Tipo" label-for="tipo">
                <b-form-input id="tipo" v-model="tipo" disabled name="tipo" />
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Sede" label-for="sede">
                <b-form-input id="sede" v-model="sede" disabled name="sede" />
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Género" label-for="genero">
                <b-form-input
                  id="genero"
                  v-model="genero"
                  disabled
                  name="genero"
                />
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group label="Hijos" label-for="hijos">
                <b-form-input
                  id="hijos"
                  v-model="hijos"
                  disabled
                  name="hijos"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-modal>
    <div>
    <Modal :visible="showModal" @close="showModal = false" :isSingleChart="tipoEvento === 'REGISTRO DE ASISTENCIA'">
      <DonutChart
        v-if="tipoEvento === 'REGISTRO DE ASISTENCIA'"
        :entregados="entregados"
        :con_absentismos="con_absentismos"
        :sin_absentismos="sin_absentismos"
        :titulo="`Público Objetivo:`"
        tooltipText="personas"
        chartClass="large-chart"
        :labels="['Asistencias', 'Con absentismos','Sin absentismos']"
      />
      <div v-else-if="tipoEvento === 'ENTREGA DE PRESENTES'" class="charts-container">
        <DonutChart
          :entregados="entregados"
          :con_absentismos="con_absentismos"
          :sin_absentismos="sin_absentismos"
          :titulo="`Público Objetivo:`"
          tooltipText="personas"
          chartClass="small-chart"
          :labels="['Entregados', 'Con absentismos','Sin absentismos']"
        />
        <DonutChart
          :entregados="entregados"
          :con_absentismos="nPremios - entregados"
          :sin_absentismos="0"
          :titulo="`Número de Premios:`"
          tooltipText="premios"
          chartClass="small-chart"
          :labels="['Entregados', 'No entregados']"
        />
      </div>
    </Modal>
    <!-- Agregar esto @ver-detalles="verDetalles" en el componente Modal -->
    <!-- <DetailsModal :visible="showDetailsModal" @close="showDetailsModal = false" :noEntregadosData="noEntregadosData" /> -->

  </div>
  </div>
</template>

<script>
import axiosIns from "../../libs/axios";
import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCol,
  BForm,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BPagination,
  BRow,
  BSpinner,
  BTable,
  VBModal,
  VBTooltip,
} from "bootstrap-vue";
import { localize, ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "@validations";
import { HotTable } from '@handsontable/vue'
import { registerAllModules } from 'handsontable/registry'
import { esMX, registerLanguageDictionary } from 'handsontable/i18n'

import 'handsontable/dist/handsontable.full.css'
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import jsPDF from 'jspdf'
import DonutChart from './DonutChart.vue'
import Modal from './Modal.vue'
import DetailsModal from './DetailsModal.vue'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

registerAllModules();
registerLanguageDictionary(esMX);

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BForm,
    BInputGroup,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BInputGroupAppend,
    BTable,
    BPagination,
    BBadge,
    BSpinner,
    BFormDatepicker,
    vSelect,
    HotTable,
    DonutChart,
    Modal,
    DetailsModal,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal": VBModal,
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      loadingDashboard : false,
      showModal: false,
      showDetailsModal: false,
      tipoEvento: '',
      entregados: 0,
      noEntregados: 0,
      con_absentismos: 0,
      sin_absentismos: 0,
      publicoObjetivo: 0,
      nPremios: 0,
      noEntregadosData: [],
      perPage: 12,
      tipoEvento: null, // Para almacenar el tipo de evento
      firmaFoto: null,  // Para almacenar si se requiere firma y foto
      pageOptions: [12, 20, 50],
      totalRows: 0,
      currentPage: 1,
      loadingExcel: false,
      filter: null,
      filterOn: [],
      estadoModal: false,
      estadoModalEditar: false,
      items: [],
      loadingPDF: false,
      itemsEntregas: [],
      items_participantes: [],
      items_participantes_todo: [],
      fields: [
        {
          key: "acciones",
          label: "#",
          tdClass: "p-1 m-1",
          thClass: "text-center py-0 alinear-medio",
        },
        {
          key: "estado",
          label: "estado",
          sortable: true,
          tdClass: "p-1 m-1 text-center",
          thClass: "text-center py-0 alinear-medio",
        },
        {
          key: "nombre",
          label: "Evento",
          sortable: true,
          tdClass: "alinear-una-sola-linea p-1 m-1",
          thClass: "text-center py-0 alinear-medio",
        },
        {
          key: "descripcion",
          label: "descripción",
          sortable: true,
          tdClass: "alinear-una-sola-linea p-1 m-1",
          thClass: "text-center py-0 alinear-medio",
        },
        {
          key: "fecha_inicio",
          label: "fecha inicio",
          sortable: true,
          tdClass: "alinear-una-sola-linea p-1 m-1 text-center",
          thClass: "text-center py-0 alinear-medio",
        },
        {
          key: "fecha_fin",
          label: "fecha fin",
          sortable: true,
          tdClass: "alinear-una-sola-linea p-1 m-1 text-center",
          thClass: "text-center py-0 alinear-medio",
        },
        {
          key: "n_participantes",
          label: "Participantes",
          sortable: true,
          tdClass: "alinear-una-sola-linea p-1 m-1 text-center",
          thClass: "text-center py-0 alinear-medio",
        },
        {
          key: "tipo",
          label: "Tipo",
          sortable: true,
          tdClass: "p-1 m-1 min-400",
          thClass: "py-0 alinear-medio",
        },
        {
          key: "opcion",
          label: "Opción",
          sortable: true,
          tdClass: "alinear-una-sola-linea p-1 m-1",
          thClass: "text-center py-0 alinear-medio",
        },
        {
          key: "sede",
          label: "Sede",
          sortable: true,
          tdClass: "alinear-una-sola-linea p-1 m-1",
          thClass: "text-center py-0 alinear-medio",
        },
        {
          key: "genero",
          label: "Género",
          sortable: true,
          tdClass: "text-center  p-1 m-1",
          thClass: "text-center py-0 alinear-medio",
        },
        {
          key: "hijos",
          label: "Hijos",
          sortable: true,
          tdClass: "alinear-una-sola-linea p-1 m-1 text-center",
          thClass: "text-center py-0 alinear-medio",
        },
        {
          key: "nombre_usuario",
          label: "Usuario",
          sortable: true,
          tdClass: "alinear-una-sola-linea p-1 m-1 text-center",
          thClass: "text-center py-0 alinear-medio",
        },
      ],
      fields_participantes: [
      {
          key: "acciones",
          label: "ACCIONES",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "estado",
          label: "estado",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "dni",
          label: "DNI",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "nombre",
          label: "Nombres",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "apellidos",
          label: "apellidos",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "sede",
          label: "sede",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "posicion",
          label: "posición",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "area",
          label: "área",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "codigo_barras",
          label: "Código de Barras",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "created",
          label: "creado",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "modified",
          label: "modificado",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "evaluador_nombre",
          label: "Evaluador",
          thClass: "text-center",
        },
      ],
      loading: false,
      loadingParticipantes: false,
      loading2: false,
      loadingEditar: false,
      mostrarParticipantes: false,
      status: [
        {
          0: "Pendiente",
          1: "Realizado",
          2: "Cancelado",
        },
        {
          0: "light-warning",
          1: "light-success",
          2: "light-danger",
        },
      ],
      status_participante: [
        {
          0: "Pendiente",
          2: "Entregado",
        },
        {
          0: "light-warning",
          2: "light-success",
        },
      ],

      labels: {
        labelPrevDecade: "Década anterior",
        labelPrevYear: "Año anterior",
        labelPrevMonth: "Mes anterior",
        labelCurrentMonth: "Mes actual",
        labelNextMonth: "Mes siguiente",
        labelNextYear: "Año siguiente",
        labelNextDecade: "Década siguiente",
        labelToday: "Hoy",
        labelSelected: "Fecha seleccionada",
        labelNoDateSelected: "Seleccione fecha",
        labelCalendar: "Calendario",
        labelNav: "Navegación por calendario",
        labelHelp: "Use las teclas de flecha para navegar por el calendario",
        labelTodayButton: "Hoy",
        labelResetButton: "Borrar",
        labelCloseButton: "Cerrar",
      },

      evento: null,
      n_premios: null,
      descripcion: null,
      fecha_inicio: null,
      fecha_fin: null,

      genero: null,
      generoLista: [],

      hijos: null,
      hijosLista: [],

      tipo_evento: 'ENTREGA DE PRESENTES',
      tipo_eventoLista: ['ENTREGA DE PRESENTES', 'REGISTRO DE ASISTENCIA'],

      codigo_barras: 'NO',
      codigo_barrasLista: ['SI', 'NO'],

      firma_foto: 'NO',
      nombre_premio: null,
      firma_fotoLista: ['SI', 'NO'],

      tipo: null,
      tipoLista: [],
      tipoListaStatic: [],

      sede: null,
      sedeLista: [],
      sedeListaStatic: [],

      opcion: null,
      opcionLista: ["TODOS", "CALIFICADOS", "NO CALIFICADOS"],
      opcionListaStatic: [],
      opcionBool: false,

      estadoSelected: null,
      estados: [
        {value: "0", text: "Pendiente"},
        {value: "2", text: "Entregado"},
      ],

      estadoEditarSelected: null,
      estadosEditar: [
        "EN PROCESO",
        "CERRADO",
        "CANCELADO",
      ],
      filtro: null,
      nombreEvento: null,
      id_evento: null,
      loading_exp: false,
      loading_expV2: false,
      loading_pdf:false,

      tableEntregas: null,
      settingsEntregas: null,
      sideImg: require('@/assets/images/logo/agvLogo.png'),
    sideImg2: require('@/assets/images/logo/arvLogo.png'),
    selloAgv: require('@/assets/images/logo/sello_agv.png'),
    selloArv: require('@/assets/images/logo/sello_arv.png'),

      required,
    };
  },
  computed: {},
  async mounted() {
    this.tableEntregas = this.$refs.hotTableEntregas.hotInstance;
    localize("es");
    await this.actualizarEstado();
    this.traerEventos();
  },
  methods: {
    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    actualizarEstado() {
      const yo = this

      const config = {
        method: "get",
        url: "/bbss/evento/editar/estado/",
      }

      axiosIns(config)
    },

    traerEventos() {
      const yo = this;
      yo.loading = true;
      yo.tableEntregas.updateData([])

      const config = {
        method: "get",
        url: "/bbss/eventos/web/",
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              yo.itemsEntregas = response.data.data;
              yo.items = JSON.parse(JSON.stringify(response.data.data));
              yo.totalRows = yo.itemsEntregas.length;
              yo.settingsEntregas = {
                width: '100%', //Ancho
                height: '59vh', //Alto
                rowHeaders: true,
                colHeaders: ['ID', 'ESTADO', 'EVENTO', 'DESCRIPCIÓN', 'FECHA INICIO', 'FECHA FIN', 'PARTICIPANTES', 'N° DE PREMIOS', 'ENTREGADOS', 'STOCK', 'TIPO', 'OPCIÓN', 'SEDE', 'GÉNERO', 'HIJOS', 'TIPO DE EVENTO', 'CÓDIGO DE BARRAS', 'FIRMA Y FOTO', 'USUARIO'],
                columns: [
                  {
                    data: 'id',
                    type: 'numeric',
                  },
                  {
                    data: 'estado',
                    editor: 'select',
                    selectOptions: [],
                    allowInvalid: false,
                    renderer(instance, td, row, col, prop, value, cellProperties) {

                      const spd = value === 'EN PROCESO' ? 'light-warning' : value === 'CERRADO' ? 'light-success' : value === 'CANCELADO' ? 'light-danger' : 'light-dark'
                      td.className = 'htCenter htMiddle'
                      td.innerHTML = '<b-badge class="badge badge-' + spd + '">' + value + '</b-badge>'

                      return td
                    }
                  },
                  {
                    data: 'nombre',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'descripcion',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'fecha_inicio',
                    type: 'date',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'fecha_fin',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'n_participantes',
                    type: 'numeric',
                    className: 'htMiddle htCenter',
                    numericFormat: {
                      pattern: '0,0'
                    },
                  },
                  {
                    data: 'n_premios',
                    type: 'numeric',
                    className: 'htMiddle htCenter',
                    numericFormat: {
                      pattern: '0,0'
                    },
                  },
                  {
                    data: 'n_participantes_estado_1',
                    type: 'numeric',
                    className: 'htMiddle htCenter',
                    numericFormat: {
                      pattern: '0,0'
                    },
                  },
                  {
                    data: 'stock',
                    type: 'numeric',
                    className: 'htMiddle htCenter',
                    numericFormat: {
                      pattern: '0,0'
                    },
                  },
                  {
                    data: 'tipo',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'opcion',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'sede',
                    type: 'text',
                    className: 'htMiddle',
                  },
                  {
                    data: 'genero',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'hijos',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'tipo_registro',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'codigo_barras',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'firma_foto',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                  {
                    data: 'nombre_usuario',
                    type: 'text',
                    className: 'htMiddle htCenter',
                  },
                ],
                contextMenu: {
                  items: {
                    edit: {
                      name: "Editar Evento",
                      callback: function () {
                        if (yo.$can('edit', 'Eventos BBSS')) {
                          const rowData = this.getDataAtRow(this.getSelected()[0][0])
                          yo.abrirModalEditar(rowData)
                        }
                      },
                    },
                    view: {
                      name: "Ver Participantes",
                      callback: function () {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0])
                        yo.tablaParticipantes(
                            rowData[0],
                            rowData[2],
                            rowData[11],
                            rowData[0],
                            rowData[15],
                            rowData[17],
                        );  
                        
                      },
                    },
                    pdf: {
                    name: 'Descargar PDF',
                    callback: function () {
                      if (yo.$can('create', 'Eventos BBSS')) {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0]);

                        if (rowData[0] != null && rowData[0] > 0  && (rowData[17] == 'NO' || rowData[15] == 'REGISTRO DE ASISTENCIA')) {
                          yo.exportarFilePDF(false, [rowData[0]]);
                        } else {
                          // Mostrar mensaje de advertencia si no se cumplen las condiciones
                          yo.$bvToast.toast('No es posible descargar PDF para este tipo de evento.', {
                            title: 'Aviso',
                            variant: 'warning', // Variantes: 'success', 'danger', 'warning', etc.
                            solid: true,
                            toaster: 'b-toaster-top-center', // Posición de la notificación
                            autoHideDelay: 5000, // Tiempo en milisegundos antes de desaparecer
                          });
                        }
                      }
                    },
                  },
                  grafico: {
                    name: 'Ver Grafico',
                    callback: function () {
                      if (yo.$can('create', 'Eventos BBSS')) {
                        const rowData = this.getDataAtRow(this.getSelected()[0][0]);

                        if (rowData[0] != null && rowData[0] > 0) {
                          yo.generarGrafico([rowData[0]],rowData[15]);
                        }
                      }
                    },
                  },
                  },
                },
                bindRowsWithHeaders: true,
                readOnly: true,
                dropdownMenu: ['filter_by_condition', 'filter_by_value', 'filter_action_bar'], // Activar menú
                filters: true,// Activar Filtro
                manualColumnResize: true,
                hiddenColumns: {
                  columns: [0],
                  indicators: false
                },
                language: esMX.languageCode,
                locale: "es-MX",
                // columnSorting: true,

                multiColumnSorting: {
                  initialConfig: [
                    {
                      column: 4,
                      sortOrder: 'desc',
                    },
                  ],
                },
              }

              yo.tableEntregas.updateData(yo.itemsEntregas)
              yo.tableEntregas.updateSettings(yo.settingsEntregas)
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function () {
            yo.loading = false;
            yo.traerResumen();
          });
    },


    async exportarFilePDF(estado, arrayS) {
      const yo = this

      yo.loadingPDF = true
      yo.estado = true
      let ids = []
      ids = estado ? yo.tabla.getData().map((subarray) => subarray[0]) : arrayS

      let spd = yo.items.filter((registro) => ids.includes(registro.id))
      if (spd.length === 0) {
        spd = yo.itemsFiltro.filter((registro) => ids.includes(registro.id))
      }

      for (const value of spd) {
        const data = JSON.stringify({
          id: value.id,
        })

        const config = {
          method: 'post',
          url: 'bbss/evento/entregas/filtrar/',
          headers: {
            'Content-Type': 'application/json',
          },
          responseType: 'blob', // Esto es importante para recibir la respuesta como un archivo
          data: data,
        }

        try {
          const response = await axiosIns(config)
          if (response.status === 200) {
            // Crear un enlace de descarga temporal
            const blob = new Blob([response.data], { type: 'application/pdf' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = 'reporte_evento.pdf' // Nombre del archivo
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        } catch (error) {
          console.error('Error al descargar el PDF:', error)
        }
      }

      yo.loadingPDF = false
    },

    async generarGrafico(id, tipoEvento) {
      const yo = this
      yo.swalLoadingInstance = this.$swal.fire({
        title: 'Cargando...',
        text: 'Por favor, espere mientras se genera el gráfico.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          yo.$swal.showLoading()
        }
      })
      let numero_id = id[0]
      yo.tipoEvento = tipoEvento
      const data = JSON.stringify({
          id: numero_id,
        })

        const config = {
          method: 'post',
          url: 'bbss/evento/entregas/grafico/',
          headers: {
            'Content-Type': 'application/json',
          },
          responseType: 'json',
          data: data,
        }

      try {
        const response = await axiosIns(config)
        if (response.status === 200) {
          const data = response.data.resultSet
          this.entregados = data.entregados
          this.noEntregados = data.no_entregados.length
          this.publicoObjetivo = data.publico_objetivo
          this.nPremios = data.n_premios
          this.noEntregadosData = data.no_entregados
          this.sin_absentismos = data.sin_absentismos
          this.con_absentismos = data.con_absentismos
          this.showModal = true
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }finally{
        yo.swalLoadingInstance.close()
      }
    },


    async cargarGrafico(id){
        this.loadingDashboard = true
        const data = JSON.stringify({
          id: id,
        })

        const config = {
          method: 'post',
          url: 'bbss/evento/entregas/grafico/',
          headers: {
            'Content-Type': 'application/json',
          },
          responseType: 'json',
          data: data,
        }

      try {
        const response = await axiosIns(config)
        if (response.status === 200) {
          const data = response.data.resultSet
          this.entregados = data.entregados
          this.noEntregados = data.no_entregados.length
          this.publicoObjetivo = data.publico_objetivo
          this.nPremios = data.n_premios
          this.noEntregadosData = data.no_entregados
          this.sin_absentismos = data.sin_absentismos
          this.con_absentismos = data.con_absentismos
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }finally{
        this.loadingDashboard = false
      }
    },

    resizeChart() {
      this.$nextTick(() => {
        if (this.$refs.donutChart) {
          this.$refs.donutChart.$refs.chartComponent.chart.updateOptions({});
        }
      });
    },

    async descargarPDFTrabajador(id) {
      this.loadingPDF = true;
      const data = JSON.stringify({ id });
      const config = {
        method: 'post',
        url: 'bbss/evento/trabajadores/filtrar/',
        headers: { 'Content-Type': 'application/json' },
        data,
        responseType: 'blob', // Importante para manejar la respuesta como archivo PDF
      };

      try {
        const response = await axiosIns(config);

        if (response.status === 200) {
          // Crear un enlace para descargar el PDF
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = 'reporte_trabajador.pdf';
          link.click();

        }
      } catch (error) {
        console.error('Error al descargar PDF:', error);
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'XIcon', // Ícono de Bootstrap Icons
              text: 'Error al descargar PDF',
              variant: 'danger',
            },
          },
          {
            position: 'top-right', // Posición mejorada
            timeout: 5000, // Duración del mensaje
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      } finally {
        this.loadingPDF = false;
      }
    },

    handleDescargarPDF(item) {
      if (item.estado == 0) {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'No permitido',
              icon: 'XIcon', // Ícono de Bootstrap Icons
              text: 'El trabajador está en estado pendiente. No se puede descargar el PDF.',
              variant: 'danger',
            },
          },
          {
            position: 'top-right', // Posición mejorada
            timeout: 5000, // Duración del mensaje
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      } else {
        this.descargarPDFTrabajador(item.id);
      }
    },


    async exportarPDFMasivos() {
      const yo = this;
      yo.loading_pdf = true; // Activa el spinner

      // Filtra los trabajadores con estado entregado
      const idsEntregados = yo.items_participantes
        .filter(participante => participante.estado === "2") // Ajusta al estado entregado ("2")
        .map(participante => participante.id);

      if (idsEntregados.length === 0) {
        // Mostrar mensaje si no hay trabajadores en estado entregado
        yo.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sin trabajadores entregados',
            icon: 'InfoIcon',
            text: 'No hay trabajadores en estado entregado para generar los PDFs.',
            variant: 'info',
          },
        });
        yo.loading_pdf = false;
        return;
      }

      // Prepara los datos para enviar a la API
      const data = JSON.stringify({ ids: idsEntregados });

      // Configuración de la solicitud
      const config = {
        method: 'post',
        url: 'bbss/evento/trabajadores/generarPDFMasivo/',
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'blob', // Importante para recibir el archivo comprimido
        data: data,
      };

      try {
        // Realiza la solicitud y espera la respuesta
        const response = await axiosIns(config);

        if (response.status === 200) {
          // Crea un enlace para descargar el archivo ZIP
          const blob = new Blob([response.data], { type: 'application/zip' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = 'pdfs_entregados.zip'; // Nombre del archivo ZIP
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Mensaje de éxito
          yo.$toast({
            component: ToastificationContent,
            props: {
              title: 'Archivo comprimido generado',
              icon: 'CheckIcon',
              text: 'El archivo comprimido con los PDFs de trabajadores entregados se descargó correctamente.',
              variant: 'success',
            },
          });
        }
      } catch (error) {
        console.error('Error al generar archivo comprimido:', error);
        yo.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'XIcon',
            text: 'Hubo un error al generar el archivo comprimido. Por favor, inténtelo nuevamente.',
            variant: 'danger',
          },
        });
      } finally {
        yo.loading_pdf = false; // Desactiva el spinner
      }
    },
    async addImageAsync(
        doc,
        url,
        format,
        x,
        y,
        width,
        height,
        alias,
        compression,
        rotation
    ) {
        return new Promise((resolve, reject) => {
            const img = new Image();

            img.onload = function () {
                // Si la imagen se carga correctamente, la agrega al documento
                doc.addImage(
                    this,
                    format,
                    x,
                    y,
                    width,
                    height,
                    alias,
                    compression,
                    rotation
                );
                resolve();
            };

            img.onerror = function () {
                // Si la imagen no se encuentra o falla la carga, no hace nada
                console.warn("Imagen no encontrada en S3:", url);
                resolve(); // Resuelve sin agregar la imagen
            };

            // Establece la URL original de la imagen
            img.src = url;
        });
    },

    traerResumen() {
      const yo = this;

      const config = {
        method: "get",
        url: "/bbss/data/completo/",
      };

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200 && response.data.status) {
            const data = response.data.data;
            yo.sedeListaStatic = response.data.data.sede;
            yo.tipoListaStatic = response.data.data.tipo;

            yo.generoLista = data.genero;
            yo.generoLista.unshift({ genero: "TODOS", count: 0 });

            yo.hijosLista = data.hijos;
            yo.hijosLista.unshift({ asignacion_familiar: "TODOS", count: 0 });

            yo.tipoLista = data.tipo;
            yo.tipoLista.unshift({
              key_tipo_planilla: "TODOS",
              nombre_tipo_planilla: "TODOS",
              count: 0,
            });

            yo.sedeLista = data.sede;
            yo.sedeLista.unshift({
              key_sede: "TODOS",
              sede: "TODOS",
              count: 0,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    abrirModalCrear() {
      const yo = this;
      yo.estadoModal = true;
    },

    abrirModalEditar(data) {
      const yo = this;
      yo.estadoModalEditar = true;

      console.log(data)

      const [day, month, year] = data[4].split("/")
      const [day_f, month_f, year_f] = data[5].split("/")

      yo.id_evento = data[0];
      yo.evento = data[2];
      yo.descripcion = data[3];
      yo.fecha_inicio = `${year}-${month}-${day}`;
      yo.fecha_fin = `${year_f}-${month_f}-${day_f}`;
      yo.genero = data[13];
      yo.hijos = data[14];
      yo.tipo = data[10];
      yo.sede = data[12];
      yo.n_premios = data[7];
      yo.codigo_barras = data[15];
      yo.estadoEditarSelected = data[1];
    },

    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },

    resetModal() {
      this.evento = null;
      this.descripcion = null;
      this.fecha_inicio = null;
      this.fecha_fin = null;
      this.genero = null;
      this.hijos = null;
      this.tipo = null;
      this.sede = null;
      this.opcion = null;
      this.n_premios = null;
      this.nombre_premio = null;
      this.opcionBool = false;
    },

    handleSubmit() {
      const yo = this;
      this.$refs.formularioEvento.validate().then((success) => {
        if (success) {
          yo.loading2 = true;

          const data = JSON.stringify({
            nombre: yo.evento,
            descripcion: yo.descripcion,
            observacion: "",
            fecha_inicio: yo.fecha_inicio,
            fecha_fin: yo.fecha_fin,
            anio: yo.fecha_inicio.split("-")[0],
            tipo: yo.tipo.map((opcion) => opcion.key_tipo_planilla),
            tipostatic: yo.tipoListaStatic
              .filter((invoice) => invoice.key_tipo_planilla !== "TODOS")
              .map((opcion) => opcion.key_tipo_planilla),
            sede: yo.sede.map((opcion) => opcion.key_sede),
            sedestatic: yo.sedeListaStatic
              .filter((invoice) => invoice.key_sede !== "TODOS")
              .map((opcion) => opcion.key_sede),
            opcion: yo.opcion,
            genero: yo.genero.genero,
            hijos: yo.hijos.asignacion_familiar,
            n_premios: yo.n_premios,
            tipo_registro: yo.tipo_evento,
            codigo_barras: yo.codigo_barras,
            firma_foto: yo.firma_foto,
            estado: "0",
            con_usuario: yo.getUserID(),
            nombre_premio:yo.nombre_premio,
          });

          const config = {
            method: "post",
            url: "bbss/evento/registrar/",
            headers: {
              "Content-Type": "application/json",
            },
            data: data,
          };

          axiosIns(config)
              .then(function (response) {
                if (response.status === 201 && response.data.status) {
                  yo.mostrarNotificacion(
                      "Registro Exitoso",
                      "CheckIcon",
                      response.data.mensaje,
                      "success"
                  );
                  yo.traerEventos();
                  yo.estadoModal = false;
                } else if (response.status === 200 && !response.data.status) {
                  yo.mostrarNotificacion(
                      "Error",
                      "BellIcon",
                      response.data.mensaje,
                      "danger"
                  );
                }
              })
              .catch(function (error) {
                console.log(error);
              })
              .finally(function () {
                yo.loading2 = false;
              });
        }
      });
    },

    cambiarTipo() {
      const lista = this.tipo.map((opcion) => opcion.key_tipo_planilla);
      console.log(lista);
      if (lista.includes("TODOS")) {
        this.tipo = [
          {
            key_tipo_planilla: "TODOS",
            nombre_tipo_planilla: "TODOS",
            count: 0,
          },
        ]
        this.opcionBool = false
      } else {
        this.opcionBool = !!(
            lista.includes("A4") ||
            lista.includes("A5") ||
            lista.includes("V4") ||
            lista.includes("V5") ||
            lista.includes("A7")
        )
      }

    },

    cambiarSede() {
      const lista = this.sede.map((opcion) => opcion.key_sede);
      if (lista.includes("TODOS")) {
        this.sede = [{ key_sede: "TODOS", sede: "TODOS", count: 0 }];
      }
    },

    tablaParticipantes(id, nombre, sede,id2,tipoEvento,firmaFoto) {
      const yo = this;

      yo.cargarGrafico(id);

      const div = document.getElementById("listEventos")
      div.style.display = "none"

      const div2 = document.getElementById("listParticipantes")
      div2.style.display = "block"

      yo.mostrarParticipantes = true;
      yo.loadingParticipantes = true;
      yo.id_evento = id;
      yo.nombreEvento = nombre;
      yo.sedeEvento = sede;
      yo.filtro = null;
      yo.estadoSelected = null;
      yo.tipoEvento = tipoEvento;
      yo.firmaFoto = firmaFoto;



      const data = JSON.stringify({
        id_evento: id,
      });

      const config = {
        method: "post",
        url: "bbss/evento/participantes/",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200 && response.data.status) {
              yo.items_participantes = response.data.data;
              yo.items_participantes_todo = response.data.data;
              yo.totalRows = yo.items_participantes.length;
              
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function () {
            yo.loadingParticipantes = false;
          });
    },

    getUserID() {
      const textUserData = localStorage.getItem("userData");
      const jsonUserData = JSON.parse(textUserData);
      return jsonUserData.id;
    },

    mostrarNotificacion(titulo, icono, texto, variante) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: titulo,
            icon: icono,
            text: texto,
            variant: variante,
          },
        },
        {
          position: "top-center",
          timeout: 5500,
        }
      );
    },

    filtros2() {
      const palabra = this.filtro !== null ? this.filtro.toLowerCase() : "";
      this.items_participantes = this.items_participantes_todo;
      this.items_participantes = this.items_participantes.filter(
        (invoice) =>
          (invoice.dni.toLowerCase().includes(palabra) ||
            invoice.nombre.toLowerCase().includes(palabra) ||
            invoice.apellidos.toLowerCase().includes(palabra)) &&
          invoice.estado === (this.estadoSelected || invoice.estado)
      );
      this.totalRows = this.items_participantes.length;
    },

    exportarFileV2() {
      const yo = this;
      yo.loading_exp = true;

      const data = JSON.stringify({
        id_evento: yo.id_evento,
        nombre_evento: yo.nombreEvento,
        sede_evento: yo.sedeEvento,
        estado_evento: yo.estadoSelected,
      });
      const config = {
        method: "post",
        url: "/bbss/evento/participantes/exportar/",
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "arraybuffer",
        data: data,
      };

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            const fileURL = window.URL.createObjectURL(
              new Blob([response.data])
            );
            const fileLink = document.createElement("a");
            fileLink.href = fileURL;

            const hoy = new Date();
            const fecha_hora =
              hoy.getFullYear() +
              "" +
              (hoy.getMonth() + 1) +
              "" +
              hoy.getDate() +
              "" +
              hoy.getHours() +
              "" +
              hoy.getMinutes() +
              "" +
              hoy.getSeconds();

            fileLink.setAttribute(
              "download",
              yo.nombreEvento + " " + fecha_hora + ".xlsx"
            );
            document.body.appendChild(fileLink);
            fileLink.click();
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: '¡Éxito!',
                    icon: 'CheckIcon', // Cambiado a ícono de éxito
                    text: 'El PDF ha sido descargado correctamente.',
                    variant: 'success', // Cambiado a variante de éxito
                  },
                },
                {
                  position: 'top-right', // Posición en la parte superior derecha
                  timeout: 5000, // Duración del mensaje en milisegundos
                  closeOnClick: true, // Cierra el toast al hacer clic
                  pauseOnHover: true, // Pausa el temporizador al pasar el mouse
                  draggable: true, // Permite mover el toast
                }
              );
            }
          })
          .catch(function (error) {
            console.log(error);
            this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'XIcon', // Ícono de Bootstrap Icons
              text: 'Error al descargar PDF',
              variant: 'danger',
            },
          },
          {
            position: 'top-right', // Posición mejorada
            timeout: 5000, // Duración del mensaje
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
          })
          .finally(function () {
            yo.loading_exp = false;
          });
    },

    exportarFile(tipoRegistro){
      const yo = this;
      if(tipoRegistro === "ENTREGA DE PRESENTES"){
        yo.loading_exp = true;
      }else{
        if(tipoRegistro === "REGISTRO DE ASISTENCIA"){
          yo.loading_expV2 = true;
        }        
      }
      

      const spd = yo.tableEntregas.getData()
      .map((subarray) => subarray[0])

      const data = JSON.stringify({
          datas: spd,
          tipo_registro: tipoRegistro,
        })

      const config = {
        method: "post",
        url: "bbss/evento/entregas/exportar/",
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "arraybuffer",
        data: data,
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              const fileURL = window.URL.createObjectURL(
                  new Blob([response.data])
              );
              const fileLink = document.createElement("a");
              fileLink.href = fileURL;

              const hoy = new Date();
              const fecha_hora =
                  hoy.getFullYear() +
                  "" +
                  (hoy.getMonth() + 1) +
                  "" +
                  hoy.getDate() +
                  "" +
                  hoy.getHours() +
                  "" +
                  hoy.getMinutes() +
                  "" +
                  hoy.getSeconds();
                  if(tipoRegistro === "ENTREGA DE PRESENTES"){
                    fileLink.setAttribute(
                    'download',
                    'REPORTE DE ENTREGAS ' + fecha_hora + '.xlsx'
                    )
                  }else{
                    fileLink.setAttribute(
                    'download',
                    'REPORTE DE ASISTENCIAS ' + fecha_hora + '.xlsx'
                    )
                  }
                  
        
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "Archivo creado",
                      icon: "CheckIcon",
                      text: "El archivo se creó satisfactoriamente.",
                      variant: "success",
                    },
                  },
                  {
                    position: "top-center",
                  }
              );
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: "Error en la creación del archivo",
                icon: "XIcon",
                text: "Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.",
                variant: "danger",
              },
            });
          })
          .finally(function () {
            if(tipoRegistro === "ENTREGA DE PRESENTES"){
              yo.loading_exp = false;
            }else{
              yo.loading_expV2 = false;
            }
          });
    },

    handleOkEditar(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmitEditar();
    },

    handleSubmitEditar() {
      const yo = this;
      this.$refs.formularioEventoEditar.validate().then((success) => {
        if (success) {
          yo.loadingEditar = true;

          const data = JSON.stringify({
            id_evento: yo.id_evento,
            nombre: yo.evento,
            descripcion: yo.descripcion,
            fecha_inicio: yo.fecha_inicio,
            fecha_fin: yo.fecha_fin,
            estado: yo.estadoEditarSelected,
            con_usuario: yo.getUserID(),
          });

          const config = {
            method: "post",
            url: "bbss/evento/editar/n/",
            headers: {
              "Content-Type": "application/json",
            },
            data: data,
          };

          axiosIns(config)
              .then(function (response) {
                if (response.status === 200 && response.data.status) {
                  yo.mostrarNotificacion(
                      "Edición Exitosoa",
                      "CheckIcon",
                      response.data.mensaje,
                      "success"
                  );
                  yo.traerEventos();
                }
                else if (response.status !== 200 && !response.data.status) {
                  yo.mostrarNotificacion(
                      "Error",
                      "BellIcon",
                      response.data.mensaje,
                      "danger"
                  );
                }
              })
              .catch(function (error) {
                console.log(error);
              })
              .finally(function () {
                yo.estadoModalEditar = false;
                yo.loadingEditar = false;
              });
        }
      });
    },

    regresar(){
      this.mostrarParticipantes = false;
      this.totalRows = this.itemsEntregas.length;

      const div = document.getElementById("listEventos")
      div.style.display = "block"

      const div2 = document.getElementById("listParticipantes")
      div2.style.display = "none"

      this.traerEventos()
    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.alinear-una-sola-linea {
  white-space: nowrap !important;
}
.min-400 {
  min-width: 350px !important;
}
.alinear-medio {
  vertical-align: middle !important;
}

.charts-container {
  display: flex; /* Activa el diseño en fila */
  flex-wrap: wrap; /* Permite que los gráficos se ajusten a nuevas líneas si el espacio es limitado */
  justify-content: space-around; /* Espaciado uniforme entre los gráficos */
  align-items: center; /* Alineación vertical */
  gap: 20px; /* Espaciado entre los gráficos */
  width: 100%; /* Asegúrate de ocupar todo el ancho del contenedor */
}

.chart-dashboard {
  width: 85%; /* Ocupa todo el ancho del contenedor */
   /*Centrar el contenido */
   display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.dashboard{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
